import { createMuiTheme } from "@material-ui/core/styles";
const bplayTheme = createMuiTheme({
    palette: {
        primary: { 500: '#467fcf' },
    },
    typography: {
        fontSize: 11,
        //htmlFontSize: 12,
        fontFamily: [
            'Arial',
            'Verdana',
            'Helvetica',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
    overrides: {
        MuiButton: {
            root: {
                fontWeight: "bold",
                margin: "10px"
            }
        },
        MuiGrid: {
            container: {
                '&$spacing-xs-2': {
                    width: `calc(100% + 5px)`,
                    margin: -5,
                    '& $item': {
                        padding: 5
                    }
                }
            },
        },
    }
});
export default bplayTheme;
